import { EnvironmentType, HeaderSettings, IHeaderSettings } from "../utils/settings"

const environment: string = process.env?.REACT_APP_ENVIRONEMENT ?? "local";

function GetEnvironment(): EnvironmentType {
    switch (environment.toLowerCase()) {
        case "local": {
            return EnvironmentType.local;
        }
        case "dev": {
            return EnvironmentType.dev;
        }
        case "qa": {
            return EnvironmentType.qa;
        }
        case "sandbox": {
            return EnvironmentType.sandbox;
        }
        case "staging": {
            return EnvironmentType.staging;
        }
        case "demo": {
            return EnvironmentType.demo;
        }
        case "prod": {
            return EnvironmentType.prod;
        }
    }

    return EnvironmentType.local;
}

function GetEnvironmentName(environment: EnvironmentType): string {
    switch (environment) {
        case EnvironmentType.local: {
            return "Local Development";
        }
        case EnvironmentType.dev: {
            return "Development";
        }
        case EnvironmentType.qa: {
            return "Quality Assurance";
        }
        case EnvironmentType.sandbox: {
            return "Sand Box";
        }
        case EnvironmentType.staging: {
            return "Staging";
        }
        case EnvironmentType.demo: {
            return "Demo";
        }
        case EnvironmentType.prod: {
            return "Production";
        }
    }
}

function DisplayEnvironmentBar(environment: EnvironmentType): boolean {
    switch (environment) {
        case EnvironmentType.local: {
            return true;
        }
        case EnvironmentType.dev: {
            return true;
        }
        case EnvironmentType.qa: {
            return true;
        }
        case EnvironmentType.sandbox: {
            return true;
        }
        case EnvironmentType.staging: {
            return true;
        }
        case EnvironmentType.demo: {
            return true;
        }
        case EnvironmentType.prod: {
            return false;
        }
    }
}

function GetHeaderHeight(environment: EnvironmentType): string {
    let isEnvironmentBarDisplayed: boolean = DisplayEnvironmentBar(environment);
    let headerSettings: IHeaderSettings = HeaderSettings();

    if (isEnvironmentBarDisplayed) {
        return headerSettings.expandedHeight;
    }

    return headerSettings.nonexpandedHeight;
}

function GetEnvironmentSettings(environment: EnvironmentType): IEnvironmentSettings {
    const environmentSettings: IEnvironmentSettings = {
        environment: environment,
        environmentName: GetEnvironmentName(environment),
        displayEnvironmentBar: DisplayEnvironmentBar(environment),
        headerHeight: GetHeaderHeight(environment)
    };

    return environmentSettings;
}

export interface IEnvironmentSettings {
    environment: EnvironmentType;
    environmentName: string;
    displayEnvironmentBar: boolean;
    headerHeight: string
};

export function EnvironmentSettings(): IEnvironmentSettings {
    const environment: EnvironmentType = GetEnvironment();
    return GetEnvironmentSettings(environment);
}